import { useSpring, animated } from '@react-spring/web';

interface IPage {
  current: number;
  total: number;
}

const BASE = 16; // your base size
const rem = (px:number) =>`${px / BASE}rem`;

const Dot = ({ active }: { active: boolean }) => {
  const props = useSpring({
    opacity: active ? 1 : 0.8,
    width: active ? rem(20) : rem(6),
    backgroundColor: active ? 'black' : '#E4E4E4',
    config: { mass: 5, tension: 500, friction: 80 },
  });
  return (
    <animated.div
      style={props}
      className="h-[6px] bg-[#E4E4E4] rounded-full"
    />
  );
};
export const DotPage: React.FC<IPage> = ({
  total,
  current,
}) => {
  return (
    <div className='flex justify-center gap-2'>
      {Array(total)
        .fill(0)
        .map((_, index) => (
          <Dot active={current === index} key={index} />
        ))}
    </div>
  );
};
